module.exports = __webpack_public_path__ + "img/selectD.4795cbb5.svg";